export { default } from './MountedFlag.vue';